import {Skeleton, TableCell, TableRow, Typography} from "@mui/material";
import React from "react";
import {NbaSummaryData} from "../../../../../../types/nbaTypes";
import {LoadingSkeleton} from "../../../../../atoms/LoadingSkeleton/LoadingSkeleton";

interface QuerySummaryTableRowProps {
    wins?: number
    losses?: number
    winPercentage?: string
    atsWins?: number
    atsLosses?: number
    atsWinPercentage?: string
    summaryData?: NbaSummaryData
    overs?: number
    unders?: number
    ouWinPercentage?: string
    loading: boolean
}

export const QuerySummaryTableRow = ({
                                         wins,
                                         losses,
                                         winPercentage,
                                         atsWins,
                                         atsLosses,
                                         atsWinPercentage,
                                         summaryData,
                                         overs,
                                         unders,
                                         ouWinPercentage,
                                         loading = false,
                                     }: QuerySummaryTableRowProps) => {

    const winLossRecord = `${wins} - ${losses} (${winPercentage})`
    const atsWinLossRecord = `${atsWins} - ${atsLosses} (${atsWinPercentage})`
    const ouRecord = `${overs} - ${unders} (${ouWinPercentage})`

    return (
        <TableRow
            sx={{
                '& > *': {
                    paddingTop: '9px !important',
                    paddingBottom: '9px !important'
                },
            }}
        >
            <TableCell align="left">
                {loading ?
                    <LoadingSkeleton height={15} width={45}/> : (
                        <Typography variant="subtitle2">
                            {winLossRecord}
                        </Typography>
                    )
                }
            </TableCell>
            <TableCell align="left">
                {loading ?
                    <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {atsWinLossRecord}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {summaryData?.avgLine?.toFixed(1)}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {summaryData?.avgAtsMargin?.toFixed(1)}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {summaryData?.avgTotal?.toFixed(1)}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {ouRecord}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {summaryData?.avgOuMargin?.toFixed(1)}
                    </Typography>
                }
            </TableCell>
            <TableCell align="left">
                {loading ? <LoadingSkeleton height={15} width={45}/> :
                    <Typography variant="subtitle2">
                        {summaryData?.avgPoints?.toFixed(1)} - {summaryData?.avgOPoints?.toFixed(1)}
                    </Typography>
                }
            </TableCell>
        </TableRow>
    )
}